import React from 'react';
import clsx from 'clsx';
import { Tabs, Tab } from 'react-bootstrap';
import { makeStyles, useTheme } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Split from 'react-split';
import PropTypes from 'prop-types';
import ButtonStyles from 'styles/theme/Button';
import FileManagerContainerStyles from 'styles/theme/Files/FileManagerContainer';
import usePreview from 'components/hook/core/usePreview';
import FileManager from 'components/widgets/filemanager/FileManager';
import FilePreviewer from 'components/widgets/filemanager/FilePreviewer';

const buttonStyles = makeStyles((theme) => ButtonStyles.getStyle(theme));
const useStyles = makeStyles((theme) => FileManagerContainerStyles.getStyle(theme));

const renderDocumentSection = (documentsProps, onPreviewDocument, classes) => (
    <>
        <div className={classes.files}>
            <FileManager
                documentProp={documentsProps[0]}
                onPreviewDocument={onPreviewDocument}
            />
        </div>
        {documentsProps.length > 1 && (
            <div className={classes.tabWrapper}>
                <Tabs
                    mountOnEnter
                    className={`${classes.borderContainer} ${classes.navbar}`}
                >
                    {documentsProps.slice(1).map((document, index) => (
                        <Tab
                            key={index + 1}
                            eventKey={index + 1}
                            title={document.label}
                            className={classes.tab}
                            mountOnEnter
                        >
                            <div className={clsx(classes.files, classes.innerFileManager)}>
                                <FileManager
                                    key={`file-manager-${index}`}
                                    documentProp={document}
                                    onPreviewDocument={onPreviewDocument}
                                />
                            </div>
                        </Tab>
                    ))}
                </Tabs>
            </div>
        )}
    </>
);

const FileManagerContainer = ({ documentsProps, previewOnDialog, height }) => {
    const classes = { ...useStyles(), ...buttonStyles() };
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const { state, onPreviewDocument, onClosePreview } = usePreview();
    return (
        <>
            <div className={classes.container} {...(height ? { style: { height } } : {})}>
                {!isMobile && !previewOnDialog && (
                    <Split
                        sizes={[50, 50]}
                        minSize={300}
                        gutterSize={10}
                        gutterAlign="center"
                        direction="horizontal"
                        cursor="col-resize"
                        className={classes.splitter}
                    >
                        <>
                            <Split
                                sizes={documentsProps.length > 1 ? [50, 50] : [100, 0]}
                                minSize={300}
                                gutterSize={10}
                                gutterAlign="center"
                                direction="vertical"
                                cursor="row-resize"
                                className={classes.associatedSplitter}
                            >
                                {renderDocumentSection(documentsProps, onPreviewDocument, classes)}
                            </Split>
                        </>
                        <FilePreviewer state={state} />
                    </Split>
                )}
                {(isMobile || previewOnDialog) && (
                    <>
                        <Split
                            sizes={documentsProps.length > 1 ? [50, 50] : [100, 0]}
                            minSize={300}
                            gutterSize={10}
                            gutterAlign="center"
                            direction="vertical"
                            cursor="row-resize"
                            className={classes.associatedSplitter}
                        >
                            {renderDocumentSection(documentsProps, onPreviewDocument, classes)}
                        </Split>
                        <FilePreviewer
                            previewOnDialog={previewOnDialog}
                            state={state}
                            onClosePreview={onClosePreview}
                        />
                    </>
                )}
            </div>
        </>
    );
};

FileManagerContainer.propTypes = {
    previewOnDialog: PropTypes.bool,
    height: PropTypes.number,
    documentsProps: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        allowedFiles: PropTypes.string,
        module: PropTypes.string.isRequired,
        lotName: PropTypes.string,
        pullDocumentsQuery: PropTypes.any.isRequired,
        getDocumentUploadSignedURL: PropTypes.any.isRequired,
        createDocumentsMutation: PropTypes.any.isRequired,
        editDocumentNameMutation: PropTypes.any.isRequired,
        deleteMutation: PropTypes.any.isRequired,
        canWrite: PropTypes.bool.isRequired,
        canDelete: PropTypes.bool.isRequired,
        maxFileSize: PropTypes.number,
        referenceId: PropTypes.number,
        referenceType: PropTypes.string.isRequired,
        referenceName: PropTypes.string.isRequired,
        getAssociatedDocumentUploadSignedURL: PropTypes.object,
        createAssociatedDocumentsMutation: PropTypes.object,
        documentTypeMutation: PropTypes.any.isRequired,
        hiddenColumns: PropTypes.array,
        customUploadButton: PropTypes.func,
        useShortColumns: PropTypes.bool,
        showFileExtension: PropTypes.bool,
        temporaryReferenceId: PropTypes.string,
    })),
};
FileManagerContainer.defaultProps = {
    previewOnDialog: false,
    height: null,
    documentsProps: [
        {
            referenceId: null,
            hiddenColumns: [],
            customUploadButton: null,
            useShortColumns: false,
            showFileExtension: false,
            temporaryReferenceId: null,
            label: '',
        },
    ],
};
export default FileManagerContainer;
